import { render } from "./RotiMainCourse.vue?vue&type=template&id=32ac1989"
import script from "./RotiMainCourse.vue?vue&type=script&lang=js"
export * from "./RotiMainCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__